import {createAction} from 'redux-actions';

export interface FetchDepotsPayload {
}

export interface FetchDepotAssetsPayload {
    depotId: string;
}

export interface FetchDoorStatusPayload {
    depotId: string;
}

export interface OpenDoorPayload {
    depotId: string;
    doorNumber: number;
    /** Acting admin's email, recorded on the event log (W2.1). */
    actorEmail?: string;
}

export interface UpdateDepotPayload {
    id: string;
    enabled: boolean;
}

export interface FetchThingsPayload {
}

export interface RestartDepotPayload {
    depotId: string;
}

export interface FetchAccessoriesPayload {
}

export interface FetchDepotBookingStatsPayload {
    depotId: string;
}

export const fetchDepots = createAction<FetchDepotsPayload>('FETCH_DEPOTS');
export const fetchDepotAssets = createAction<FetchDepotAssetsPayload>('FETCH_DEPOT_ASSETS');
export const fetchDoorStatus = createAction<FetchDoorStatusPayload>('FETCH_DOOR_STATUS');
export const openDoor = createAction<OpenDoorPayload>('OPEN_DOOR');
export const updateDepot = createAction<UpdateDepotPayload>('UPDATE_DEPOT');
export const fetchThings = createAction<FetchThingsPayload>('FETCH_THINGS');
export const restartDepot = createAction<RestartDepotPayload>('RESTART_DEPOT');
